import makeStyles from '@mui/styles/makeStyles';
import {find} from 'lodash';
import React from 'react';
import {useTranslation} from "react-i18next";
import {Redirect, Route, Switch} from "react-router-dom";
import {color, space} from "common/tokens";
import useFreshData, {dataKeys} from "common/useFreshData";
import CodeofConduct from "components/CodeofConduct";
import FAQ from "components/FAQ";
import ProfileSidebar from "components/ProfileSidebar";
import MyProfileContainer from "containers/MyProfileContainer";

const useStyles = makeStyles(theme => ({
  page: {
    background: color.SURFACE_MUTED,
    minHeight: '100%',
  },
  container: {
    width: '100%',
    maxWidth: space.CONTAINER_MAX,
    margin: '0 auto',
    padding: '40px 32px 64px',
    boxSizing: 'border-box',
    display: 'flex',
    gap: 33,
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '24px 16px 48px',
      gap: 24,
    },
  },
  main: {
    flex: '1 1 0',
    minWidth: 0,
  },
}));

export const getItem = (community, id) => find(community, item => item.id === id) || {};

const MoreInfo = ({displayName, firstName, role, community, faqTopics, loadCommunity}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  useFreshData(dataKeys.COMMUNITY, loadCommunity);

  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <ProfileSidebar firstName={firstName || displayName} role={role}/>

        <div className={classes.main}>
          <Switch>
            <Route exact path={'/moreinfo'} component={MyProfileContainer}/>
            <Route exact path={'/moreinfo/faq'}>
              <FAQ faqTopics={faqTopics}/>
            </Route>
            <Route exact path={'/moreinfo/privacyPolicy'}>
              <CodeofConduct title={t('privacyPolicy')} content={getItem(community, 3)}/>
            </Route>
            <Route exact path={'/moreinfo/termsOfService'}>
              <CodeofConduct title={t('termsOfService')} content={getItem(community, 4)}/>
            </Route>
            <Route exact path={'/moreinfo/codeofconduct'}>
              <CodeofConduct title={t('codeOfConduct')} content={getItem(community, 6)}/>
            </Route>
            {/* The profile used to hang off the work-readiness route. */}
            <Redirect to={'/moreinfo'}/>
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default MoreInfo;
